import { config } from '@/config';
import { getOldLocaleByNew, LanguageMap } from '@/utils/locales';

export const getLinkToTranslation = (href: string): string => {
    if (!href) {
        console.error('getLinkToTranslation received an undefined or empty href.');
        return '/';
    }

    const segments = href.split('/').filter(Boolean);
    const locale = segments[0] || '';
    const langCodeContentful = getOldLocaleByNew(locale)

    if (process.env.NEXT_PUBLIC_USE_LOCALIZED_LINKS === '0') {
        if (config.language.default === langCodeContentful) {
            return href;
        }
        const multiSiteUrl = process.env.NEXT_PUBLIC_MULTI_LOCAL_SITE_URL || '';
        return `${multiSiteUrl}${href}`;
    }

    if (LanguageMap[langCodeContentful]?.separateDomain) {
        return process.env.NEXT_PUBLIC_CN_SITE_URL || href;
    }

    return href;
};
